<script lang="ts">
    import {storable} from "../storable.ts";
    import {email, fetchOrigin, page} from "../data.ts";

    const lastSentCode = storable('WOB.lastSentCode', 0)
    let msg = '';

    async function sendCode() {
        msg = '';
        if (!email) return msg = 'Please enter an email';
        lastSentCode.set(Date.now())

        const result = await fetchOrigin(`/send-code/?${new URLSearchParams({email: $email}).toString()}`);
        const json = await result.json();
        console.log(json)
        if (json.error) {
            msg = json.error;
            return;
        }

        page.set('EnterCode')
    }
</script>

<article style="max-width: 720px; margin: 2rem auto;">
    <h1>Enter your email</h1>
    <p>
        If you have already registered, be sure to use the same email you registered with.
    </p>

    {#if msg}
        <div class="alert alert-warning">
            {msg}
        </div>
    {/if}

        <label>
            Email
            <input type="email" name="email" placeholder="you@example.com" required bind:value={$email}/>
        </label>

        <button on:click={sendCode}>Submit</button>
</article>